export default {
  "description": "Web developer じゅんかた のサイト",
}